import { render, staticRenderFns } from "./applicationUsersDashboard.vue?vue&type=template&id=5139f13e"
import script from "./applicationUsersDashboard.vue?vue&type=script&lang=js"
export * from "./applicationUsersDashboard.vue?vue&type=script&lang=js"
import style0 from "./applicationUsersDashboard.vue?vue&type=style&index=0&id=5139f13e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports